import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Storage } from "../../Firebase/firebase";
import { ToastContainer, toast } from "react-toastify";
import { addBenefit, userService } from "../../../_services/user.service";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import "./AddBenefitFinal.css";

export default function AddBenefitFinal() {
    const { t } = useTranslation();
    const clubBusineesMemberid = useParams();
    const [searchParams] = useSearchParams();
    const clubBusinessMember = JSON.parse(localStorage.getItem("clubBusinessMember"));;
    const navigate = useNavigate();
    const clubOfferRef = useRef();
    const [clubName, setClubName] = useState("");

    let [disableBtn, setDisableBtn] = useState(false);
    const [largeImageURL, setLargeImageURL] = useState("");
    const [smallImageURL, setSmallImageURL] = useState("");
    const [descriptionLength, setDescriptionLength] = useState("");
    const [longDescriptionLength, setLongDescriptionLength] = useState("");
    const [priceValue, setPriceValue] = useState("");
    const [pointsValue, setPointsValue] = useState("");
    const [discountValue, setDiscountValue] = useState("");
    const [priceBeforeDiscount, setPriceBeforeDiscount] = useState("");
    const [priceAfterDiscount, setPriceAfterDiscount] = useState("");
    const [itemAmount, setItemAmount] = useState("");
    const [giftAmount, setGiftAmount] = useState("");
    const [itemPriceForGift , setItemPriceForGift] = useState("");
    const [possiblePurchase, setPossiblePurchase] = useState("null");
    const [benefitArray, setBenefitArray] = useState([]);
    const [benefitType, setBenefitType] = useState(searchParams.get('type') || "");
    const [prepaidSubtype, setPrepaidSubtype] = useState(searchParams.get('prepaidSubtype') || "");

    useEffect(() => {
        if (!benefitType) {
            navigate(-1);
        }
        const fetchClubDetails = async () => {
            //try {
                //const clubs = await userService.getAllClubsOfBusiness();
                //const club = clubs.find(c => c.id === clubBusinessMember.clubId);
                const club = clubBusinessMember.clubPublicInformation;
                if (club == null) 
                    console.error("Error fetching clubPuclicinformation details:");
                setClubName(club.name);
             //   }
            // } catch (error) {
            //     console.error("Error fetching club details:", error);
            // }
        };
        fetchClubDetails();
    },[benefitType, navigate]);

    const getBenefitTitle = () => {
        switch (benefitType) {
            case "prepaid":
                return prepaidSubtype === "all" ? t('createPrepaidCardAll') : t('createPrepaidCardItems');
            case "punch":
                return t('createPunchCardBenefit');
            case "free":
                return t('createOneTimeBenefit');
            default:
                return t('createNewBenefit');
        }
    };

    const isPrepaidAll = benefitType === "prepaid" && prepaidSubtype === "all";
    const isPrepaidItems = benefitType === "prepaid" && prepaidSubtype === "items";
    const isPrepaid = benefitType === "prepaid";

    const smallImageHandler = async (e) => {
        if (e.target.files[0] == null) return;

        var img = new Image();
        img.src = window.URL.createObjectURL(e.target.files[0]);
        img.onload = async function () {
            var width = img.naturalWidth,
                height = img.naturalHeight;

            if (height > 40) {
                const storageRef = ref(Storage, `/logos/${e.target.files[0].name}`);

                toast.loading("Uploading Image");
                try {
                    const uploadTask = await uploadBytes(storageRef, e.target.files[0]);
                    toast.dismiss();
                    toast.success("Small Image Uploaded");
                    setDisableBtn(false);
                } catch (e) {
                    toast.dismiss();
                    toast.error("Failed");
                    setDisableBtn(false);
                }

                getDownloadURL(ref(Storage, `/logo/${e.target.files[0].name}`)).then(
                    (url) => {
                        setSmallImageURL(url);
                    }
                );
                e.target.value = "";
            } else {
                toast.error("Image size doesnot match");
            }
        };
    };

    const largeImageHandler = async (e) => {
        if (e.target.files[0] == null) return;

        var img = new Image();
        img.src = window.URL.createObjectURL(e.target.files[0]);
        img.onload = async function () {
            var width = img.naturalWidth,
                height = img.naturalHeight;

            if (width > 79 && height > 79) {
                const storageRef = ref(Storage, `/logo/${e.target.files[0].name}`);
                toast.loading("Uploading Image");
                try {
                    const uploadTask = await uploadBytes(storageRef, e.target.files[0]);
                    toast.dismiss();
                    toast.success("Big Image Uploaded");
                    setDisableBtn(false);
                } catch (e) {
                    toast.dismiss();
                    toast.error("Failed");
                    setDisableBtn(false);
                }

                getDownloadURL(ref(Storage, `/logo/${e.target.files[0].name}`)).then(
                    (url) => {
                        setLargeImageURL(url);
                    }
                );
                e.target.value = "";
            } else {
                toast.error("Image size doesnot match");
            }
        };
    };

    const clubOfferSubmitHandler = async (e) => {
        e.preventDefault();

        if (possiblePurchase.value === "choose option") {
            toast.error("Please choose option from Possible Purchase.");
            return;
        }

        // Validate required fields for prepaid all
        if (isPrepaidAll) {
            if (!priceValue || !pointsValue) {
                toast.error("Please fill in all required fields");
                return;
            }
            // Ensure numeric values
            if (isNaN(Number(pointsValue)) || isNaN(Number(discountValue))) {
                toast.error("Points and discount values must be numbers");
                return;
            }
        }

        try {
            let data = {
                price: benefitType === "prepaid" ? priceValue : 0,
                priceBeforeDiscount: benefitType === "free" ? priceBeforeDiscount || "" : null,
                priceAfterDiscount: benefitType === "free" ? priceAfterDiscount || "" : null,
                points: benefitType === "free" ? priceAfterDiscount || "" :
                    benefitType === "punch" ? itemAmount || "" :
                        isPrepaidAll ? pointsValue || "" : itemAmount || "",
                discountAmount: benefitType === "free" ? (priceBeforeDiscount - priceAfterDiscount) || "" :
                    benefitType === "punch" ? (itemPriceForGift * giftAmount) || "" :
                        isPrepaidAll ? (pointsValue - priceValue) || "" : (itemPriceForGift * giftAmount) || "",
                possiblePurchases: possiblePurchase === "null" ? null : possiblePurchase,
                description: descriptionLength || "",
                longDescription: longDescriptionLength || "",
                smallPicturlUrl: smallImageURL || "",
                largePicturlUrl: largeImageURL || "",
                type: benefitType,
                prepaidSubtype: prepaidSubtype,
                clubId: clubBusinessMember?.clubId || null,
                businessId: clubBusinessMember?.businessId || null
            };

            // Additional validation for prepaid all
            if (benefitType === "prepaid") {
                // Ensure points and discountAmount are numbers
                data.points = Number(data.points);
                data.discountAmount = Number(data.discountAmount);
                data.selfRedeemAllowed = true;
                if (isPrepaidAll){
                    data.displayPunchesImage = false
                } else {
                    data.displayPunchesImage = true;
                }
            }

            if ( benefitType === "punch"){
                // Set price to 0 for prepaid all since it's not used
                data.price = "0";
                data.displayPunchesImage = true;
                
            }

            toast.loading("Creating benefit...");
            console.log("Sending data to server:", data);

            const response = await addBenefit({
                clubId: clubBusinessMember.clubId,
                benefit: data,   // here "data" is your object
            });

            toast.dismiss();
            if (response.statue == "NOT_FOUND") {
                toast.error("Benefit wasn't added. please try again./n " +
                    "if not sucseed contact support");
                return;
            }

            console.log("Server response:", response);

            const updatedOffers = {
                response,
                isEditing: false,
                isLoading: false,
                originalValues: {response }
            }

            // const updatedOffers = response?.map((offer) => ({
            //     ...offer,
            //     isEditing: false,
            //     isLoading: false,
            //     originalValues: { ...offer }
            // }));
            setBenefitArray(updatedOffers);

            toast.success("Benefit Added Successfully");
            clearValues();
            navigate(`/home/ManageClubs/${clubBusineesMemberid}/benefitsList`, 
                { state: { updatedOffers } } );
        } catch (err) {
            toast.dismiss();
            console.error("Error creating benefit:", err);

            if (err.message.includes("<!doctype")) {
                toast.error("Server error occurred. Please try again later.");
            } else {
                toast.error(err.message || "Failed to create benefit");
            }
        }

    };

    const clearValues = () => {
        setPriceValue("");
        setPointsValue("");
        setPossiblePurchase("null");
        setDiscountValue("");
        setPriceBeforeDiscount("");
        setPriceAfterDiscount("");
        setGiftAmount("");
        setDescriptionLength("");
        setLongDescriptionLength("");
        setSmallImageURL("");
        setLargeImageURL("");
    };

    return (
        <div className="add-benefit-container">
            <div className="add-benefit-form-container">
                <div className="form-card-accent"></div>
                <div className="add-benefit-form-header">
                    <button
                        onClick={() => navigate(-1)}
                        className="add-benefit-back-button"
                    >
                        <ArrowRight className="back-button-icon" />
                        {t('backToBenefits')}
                    </button>
                    <h1>{getBenefitTitle()}</h1>
                    <p>{t('createBenefitDescription')}</p>
                    <p>{t('newBenefitToClub')} {clubName}</p>
                </div>

                <form onSubmit={clubOfferSubmitHandler} className="add-benefit-form">
                    <div className="add-benefit-form-content">
                        <div className="add-benefit-form-row">
                            <div className="add-benefit-form-group">
                                <label className="add-benefit-form-label">
                                    {benefitType === "punch"
                                        ? t('itemAmount')
                                        : benefitType === "free"
                                            ? t('priceBeforeDiscount')
                                            : isPrepaidAll
                                                ? t('totalPrice')
                                                : t('totalPrice')}
                                </label>
                                <input
                                    type="number"
                                    name="price"
                                    value={benefitType === "free" ? priceBeforeDiscount :
                                        benefitType === "punch" ? 0 : priceValue }
                                    onChange={(e) => {
                                        if (benefitType === "free") {
                                            setPriceBeforeDiscount(e.target.value);
                                        } else if (benefitType === "punch") {
                                            setItemAmount(e.target.value);
                                        }
                                        else {
                                            setPriceValue(e.target.value);
                                        }
                                    }}
                                    placeholder={
                                        benefitType === "punch"
                                            ? t('itemAmountPlaceholder')
                                            : benefitType === "free"
                                                ? t('priceBeforeDiscountPlaceholder')
                                                : t('totalPricePlaceholder')}
                                    required
                                    className="add-benefit-form-input"
                                />
                            </div>

                            <div className="add-benefit-form-group">
                                <label className="add-benefit-form-label">
                                    {benefitType === "punch"
                                        ? t('giftAmount')
                                        : benefitType === "free"
                                            ? t('priceAfterDiscount')
                                            : isPrepaidAll
                                                ? t('cardAmount')
                                                : t('giftAmount')}
                                </label>
                                <input
                                    type="number"
                                    name="points"
                                    value = {benefitType === "free" ? priceAfterDiscount :
                                        benefitType== "punch"  ? giftAmount() :
                                            isPrepaidAll ? pointsValue : giftAmount}
                                    onChange={(e) => {
                                        if (benefitType === "free") {
                                            setPriceAfterDiscount(e.target.value);
                                        } else if (benefitType == "punch") {
                                            setGiftAnoumt(e.target.value);
                                        } else if (isPrepaidAll) {
                                            setPointsValue(e.target.value);
                                        } else {
                                            setGiftAmount();
                                        }
                                    }}
                                    placeholder={
                                        benefitType === "punch"
                                            ? t('giftAmountPlaceholder')
                                            : benefitType === "free"
                                                ? t('priceAfterDiscountPlaceholder')
                                                : isPrepaidAll
                                                    ? t('cardAmountPlaceholder')
                                                    : t('giftAmountPlaceholder')}
                                    required
                                    className="add-benefit-form-input"
                                />
                            </div>
                        </div>

                        <div className="add-benefit-form-row">
                            {!isPrepaidAll && benefitType !== "free" && (
                                <div className="add-benefit-form-group">
                                    <label className="add-benefit-form-label">
                                        {benefitType === "punch"
                                            ? t('itemPriceForGiftItem')
                                            : benefitType === "free"
                                                ? t('discountAmount')
                                                : t('totalDiscount')}
                                    </label>
                                    <input
                                        type="number"
                                        name="discount"
                                        value= {benefitType == "free" ?
                                            (priceBeforeDiscount - priceAfterDiscount):
                                            isPrepaidAll ? (pointsValue - priceValue) : itemPriceForGift }
                                        onChange={(e) => setDiscountValue(e.target.value)}
                                        placeholder={
                                            benefitType === "punch"
                                                ? t('itemPriceForGiftItemPlaceholder')
                                                : benefitType === "free"
                                                    ? t('totalDiscountPlaceholder')
                                                    : isPrepaidAll
                                                        ? t('totalDiscountPlaceholder'):
                                                        t('itemPriceForGiftItemPlaceholder')}
                                        required={benefitType === "punch" ? true : false}
                                        className="add-benefit-form-input"
                                    />
                                </div>
                            )}

                            <div className="add-benefit-form-group">
                                <label className="add-benefit-form-label">
                                    {t('purchaseLimit')}
                                </label>
                                <div className="add-benefit-radio-group">
                                    <label className={`add-benefit-radio-option ${possiblePurchase === "null" ? "active" : ""}`}>
                                        <input
                                            type="radio"
                                            name="possiblePurchase"
                                            value="null"
                                            checked={possiblePurchase === "null"}
                                            onChange={(e) => setPossiblePurchase(e.target.value)}
                                        />
                                        <span>{t('unlimited')}</span>
                                    </label>
                                    <label className={`add-benefit-radio-option ${possiblePurchase === "1" ? "active" : ""}`}>
                                        <input
                                            type="radio"
                                            name="possiblePurchase"
                                            value="1"
                                            checked={possiblePurchase === "1"}
                                            onChange={(e) => setPossiblePurchase(e.target.value)}
                                        />
                                        <span>{t('once')}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="add-benefit-form-group">
                            <label className="add-benefit-form-label">{t('offerDescription')}</label>
                            <input
                                placeholder={t('benefDescriptionPlaceholder')}
                                value={descriptionLength}
                                onChange={(e) => {
                                    setDescriptionLength(e.target.value);
                                }}
                                maxLength={30}
                                name="description"
                                rows="3"
                                className="add-benefit-form-input"
                            />
                            <p className="add-benefit-error-message">
                                {descriptionLength?.length || 0}/30
                            </p>
                        </div>

                        <div className="add-benefit-form-group">
                            <label className="add-benefit-form-label">{t('longOfferDescription')}</label>
                            <input
                                placeholder={t('benefLongDescriptionPlaceholder')}
                                value={longDescriptionLength}
                                onChange={(e) => {
                                    setLongDescriptionLength(e.target.value);
                                }}
                                maxLength={150}
                                name="longDescription"
                                className="add-benefit-form-input"
                            />
                            <p className="add-benefit-error-message">
                                {longDescriptionLength?.length || 0}/150
                            </p>
                        </div>

                        <div className="add-benefit-logo-upload-container">
                            <div className="add-benefit-logo-upload">
                                <h2 className="add-benefit-type-label">{t('smallLogo')}</h2>
                                <div className="add-benefit-logo-preview">
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setDisableBtn(true);
                                            smallImageHandler(e);
                                        }}
                                        accept="image/*"
                                    />
                                    {smallImageURL && <img src={smallImageURL} alt="Small Logo" />}
                                    {!smallImageURL && <span>{t('noImageSelected')}</span>}
                                </div>
                                <p className="add-benefit-error-message">min 141*80</p>
                            </div>

                            <div className="add-benefit-logo-upload">
                                <h2 className="add-benefit-type-label">{t('largeLogo')}</h2>
                                <div className="add-benefit-logo-preview">
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setDisableBtn(true);
                                            largeImageHandler(e);
                                        }}
                                        accept="image/*"
                                    />
                                    {largeImageURL && <img src={largeImageURL} alt="Large Logo" />}
                                    {!largeImageURL && <span>{t('noImageSelected')}</span>}
                                </div>
                                <p className="add-benefit-error-message">min 450*200</p>
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="add-benefit-submit-button"
                        disabled={disableBtn}
                    >
                        {t('createBenefit')}
                    </button>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
}
